import React from 'react';
import MenuItems from "./MenuItems";
import {withRouter} from "../../utils/withRouter";
import { Link } from "react-router-dom";
import {checkPermission} from "../../utils/common";
import './styles.css';

class Sidebar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            items: [],
            expandedMenus: {},
            sidebarCollapsed: localStorage.getItem('sas_sidebar_collapsed') === 'true'
        }
    }

    componentDidMount() {
        this.initializeMenu();

        // Apply sidebar collapsed state on mount
        if (this.state.sidebarCollapsed) {
            document.getElementById('mainContainer')?.classList.add('sidebar-collapsed');
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.parentClass !== this.props.parentClass) {
            this.setState(prev => ({
                expandedMenus: {
                    ...prev.expandedMenus,
                    [this.resolveParentClass()]: true
                }
            }));
        }
    }

    /* Nhóm menu chứa trang hiện tại. Ưu tiên khớp URL (longest match trên url của
     * nhóm/mục con) vì các trang cũ vẫn truyền parentClass theo tên nhóm TRƯỚC khi
     * tái cấu trúc; nếu URL không khớp thì quy đổi parentClass cũ qua 'aliases'. */
    resolveParentClass = () => {
        const path = window.location.pathname;
        let best = null, bestLen = -1;
        for (const item of MenuItems.AdminSchool) {
            if (item.type === 'section') continue;
            const urls = [item.url, ...(item.children || []).map(c => c.url)];
            for (const url of urls) {
                if (url && path.startsWith(url) && url.length > bestLen) {
                    best = item.activeClass;
                    bestLen = url.length;
                }
            }
        }
        if (best) return best;

        const { parentClass } = this.props;
        if (!parentClass) return null;
        for (const item of MenuItems.AdminSchool) {
            if (item.type === 'section') continue;
            if (item.activeClass === parentClass || (item.aliases || []).includes(parentClass)) {
                return item.activeClass;
            }
        }
        return parentClass;
    }

    initializeMenu = () => {
        let allMenuItems = JSON.parse(JSON.stringify(MenuItems.AdminSchool));

        for (let i = 0; i < allMenuItems.length; i++) {
            let item = allMenuItems[i];
            if (item.type === 'section') continue;
            let permissionArr = item.permission.split("|");
            let isShow = false;

            for (let i1 = 0; i1 < permissionArr.length; i1++) {
                isShow = checkPermission(permissionArr[i1]);
                if (isShow) break;
            }
            item.isShow = isShow;

            let children = item.children;
            if (children) {
                for (let y = 0; y < children.length; y++) {
                    let childPermissionArr = children[y].permission.split("|");
                    let childIsShow = false;

                    for (let y1 = 0; y1 < childPermissionArr.length; y1++) {
                        childIsShow = checkPermission(childPermissionArr[y1]);
                        if (childIsShow) break;
                    }
                    children[y].isShow = childIsShow;
                }
            }
        }

        const resolvedParent = this.resolveParentClass();
        const expandedMenus = {};
        if (resolvedParent) {
            expandedMenus[resolvedParent] = true;
        }

        this.setState({
            items: allMenuItems,
            expandedMenus
        });
    }

    toggleMenu = (activeClass) => {
        this.setState(prev => ({
            expandedMenus: {
                ...prev.expandedMenus,
                [activeClass]: !prev.expandedMenus[activeClass]
            }
        }));
    }

    isMenuExpanded = (item) => {
        const { expandedMenus } = this.state;

        // Kiểm tra xem user đã toggle menu này chưa
        if (expandedMenus.hasOwnProperty(item.activeClass)) {
            return expandedMenus[item.activeClass];
        }

        // Mặc định mở menu chứa trang hiện tại
        if (item.activeClass === this.resolveParentClass()) return true;

        return false;
    }

    getVisibleChildrenCount = (children) => {
        if (!children) return 0;
        return children.filter(child => child.isShow).length;
    }

    /* Bấm icon trên rail thu gọn: mở lại sidebar và bung đúng nhóm đó */
    expandFromRail = (activeClass) => {
        this.setState(prev => ({
            expandedMenus: {
                ...prev.expandedMenus,
                [activeClass]: true
            }
        }));
        this.toggleSidebar();
    }

    toggleSidebar = () => {
        const newState = !this.state.sidebarCollapsed;
        this.setState({ sidebarCollapsed: newState });
        localStorage.setItem('sas_sidebar_collapsed', newState.toString());

        const mainContainer = document.getElementById('mainContainer');
        if (mainContainer) {
            if (newState) {
                mainContainer.classList.add('sidebar-collapsed');
            } else {
                mainContainer.classList.remove('sidebar-collapsed');
            }
        }
    }

    render() {
        const { activeClass } = this.props;
        const { items, sidebarCollapsed } = this.state;
        const resolvedParent = this.resolveParentClass();

        // Section đi kèm nhóm phía sau nó: nếu cả cụm bị ẩn theo quyền thì ẩn luôn section
        const shown = items.filter(item => item.type === 'section' || item.isShow);
        const visibleItems = shown.filter((item, i) =>
            item.type !== 'section' || (shown[i + 1] && shown[i + 1].type !== 'section')
        );

        return (
            <div className={`col-md-2 p-0 pr-3 sidebar-column ${sidebarCollapsed ? 'collapsed' : ''}`}>
                {/* Thu gọn: rail icon — mỗi nhóm 1 icon, bấm là mở lại menu đúng nhóm */}
                {sidebarCollapsed && (
                    <div className="sidebar-mini-rail">
                        <button
                            className="sidebar-collapsed-toggle"
                            onClick={this.toggleSidebar}
                            type="button"
                            title="Mở menu"
                        >
                            <i className="fas fa-chevron-right"></i>
                        </button>
                        {visibleItems.map((item, index) => {
                            if (item.type === 'section') return null;
                            const isActive = activeClass === item.activeClass || resolvedParent === item.activeClass;
                            const iconClass = item.icon.replace('font-18 icon-side-bar', '');
                            return this.getVisibleChildrenCount(item.children) > 0 ? (
                                <button
                                    key={index}
                                    type="button"
                                    className={`sidebar-mini-item ${isActive ? 'active' : ''}`}
                                    title={item.title}
                                    onClick={() => this.expandFromRail(item.activeClass)}
                                >
                                    <i className={iconClass}></i>
                                </button>
                            ) : (
                                <Link
                                    key={index}
                                    to={item.url || '#'}
                                    className={`sidebar-mini-item ${isActive ? 'active' : ''}`}
                                    title={item.title}
                                >
                                    <i className={iconClass}></i>
                                </Link>
                            );
                        })}
                    </div>
                )}

                <div className="sidebar-wrapper">
                    {/* Nút thu gọn ghim mép phải — không chiếm hàng riêng */}
                    <button
                        className="sidebar-toggle-btn"
                        onClick={this.toggleSidebar}
                        type="button"
                        title="Thu gọn menu"
                    >
                        <i className="fas fa-chevron-left"></i>
                    </button>

                    {/* Menu Container */}
                    <div className="sidebar-menu-container">
                        {visibleItems.length > 0 && (
                            <ul className="sidebar-menu">
                                {visibleItems.map((item, index) => {
                                    if (item.type === 'section') {
                                        return (
                                            <li key={index} className="sidebar-section-label">
                                                <span>{item.title}</span>
                                            </li>
                                        );
                                    }
                                    const hasChildren = item.children && item.children.length > 0;
                                    const visibleChildrenCount = this.getVisibleChildrenCount(item.children);
                                    const isExpanded = this.isMenuExpanded(item);
                                    const isActive = activeClass === item.activeClass || resolvedParent === item.activeClass;

                                    return (
                                        <li key={index} className="sidebar-menu-item">
                                            {hasChildren && visibleChildrenCount > 0 ? (
                                                <>
                                                    <div
                                                        className={`sidebar-menu-link ${isActive ? 'active' : ''} ${isExpanded ? 'expanded' : ''}`}
                                                        onClick={() => this.toggleMenu(item.activeClass)}
                                                    >
                                                        <div className="sidebar-menu-icon">
                                                            <i className={item.icon.replace('font-18 icon-side-bar', '')}></i>
                                                        </div>
                                                        <span className="sidebar-menu-text">{item.title}</span>
                                                        <span className="sidebar-menu-badge">{visibleChildrenCount}</span>
                                                        <i className="fas fa-chevron-right sidebar-menu-arrow"></i>
                                                    </div>
                                                    <ul className={`sidebar-submenu ${isExpanded ? 'expanded' : ''}`}>
                                                        {item.children.map((child, childIndex) => (
                                                            child.isShow && (
                                                                <li key={childIndex} className="sidebar-submenu-item">
                                                                    <Link
                                                                        to={child.url}
                                                                        className={`sidebar-submenu-link ${activeClass === child.activeClass ? 'active' : ''}`}
                                                                    >
                                                                        <span>{child.title}</span>
                                                                    </Link>
                                                                </li>
                                                            )
                                                        ))}
                                                    </ul>
                                                </>
                                            ) : (
                                                <Link
                                                    to={item.url || '#'}
                                                    className={`sidebar-menu-link ${isActive ? 'active' : ''}`}
                                                >
                                                    <div className="sidebar-menu-icon">
                                                        <i className={item.icon.replace('font-18 icon-side-bar', '')}></i>
                                                    </div>
                                                    <span className="sidebar-menu-text">{item.title}</span>
                                                </Link>
                                            )}
                                        </li>
                                    );
                                })}
                            </ul>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(Sidebar);
